import { render } from "./WhitepaperButton.vue?vue&type=template&id=7bec3568&ts=true"
import script from "./WhitepaperButton.vue?vue&type=script&lang=ts"
export * from "./WhitepaperButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__